import {Department} from '@app/core/models/department.model';

export interface IDepartmentState {
	departments: Department[];
	isLoading: boolean;
}

export const initialDepartmentState: IDepartmentState = {
	departments: [],
	isLoading: false,
};
